import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// theme.scss imports Bootstrap from source with brand-color overrides;
// no separate bootstrap CSS import needed. Order matters — bring it in
// before the app so component CSS classes are defined when React renders.
import "@/theme/theme.scss";

import { App } from "@/App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the push/installability service worker at boot — NOT lazily when the
// user opts into notifications. The browser only offers "Install app" once a
// registered worker exists, so registering here is what makes the app installable
// before anyone visits Preferences. It has no fetch handler, so it never
// intercepts navigation or asset loads (see public/sw.js).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* non-fatal — the app works, it just isn't installable and can't receive push */
    });
  });
}
